export default "<app-header></app-header>\n<app-hero></app-hero>\n<app-maps></app-maps>\n<app-footer></app-footer>";